import styled from "styled-components";
import { device } from "@constants/styles";
import { colors } from "@constants/colors";

// Shared styled pieces for the metric-detail filter bar (unit / date / period).
// Kept here so the per-metric pages can compose their own filter bar while
// reusing the exact date-picker styling.
export const TextDatePick = styled.div`
  position: absolute;
  z-index: 1;
  color: #919eab;
  font-family: "SukhumvitSet-Text";
  font-weight: 400;
  font-size: 0.833vw;
  left: 0.972vw;
  top: -0.556vw;
  background: #fff;
  display: inline-block;
  padding: 0 0.278vw;
  @media ${device.desktopL} {
    padding: 0 4px;
    font-size: 12px;
    left: 14px;
    top: -8px;
  }
`;

export const DatePick = styled.div`
  position: relative;
  & .ant-picker {
    width: 100%;
    border-radius: 0.556vw;
    padding: 1.007vw 1.111vw;
    font-size: 1.389vw;
    border: 0.069vw solid rgba(145, 158, 171, 0.32);
    &:hover {
      border-color: rgb(255, 187, 84);
    }
    @media ${device.desktopL} {
      border-radius: 8px;
      padding: 14.5px 16px;
      font-size: 20px;
      border: 1px solid rgba(145, 158, 171, 0.32);
    }
  }
  & .ant-picker-input > input {
    font-size: 0.972vw;
    font-family: SukhumvitSet-Text, sans-serif;
    color: ${colors.gray333};
    @media ${device.desktopL} {
      font-size: 14px;
    }
  }
  & .ant-picker-focused {
    box-shadow: none;
    border-color: rgb(255, 187, 84);
  }
  & .ant-picker-range .ant-picker-active-bar {
    background: rgb(255, 187, 84);
  }
  &
    .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner:before {
    border: 1px solid rgb(255, 187, 84);
  }
  & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: rgb(255, 187, 84);
  }
  & .ant-picker-cell-in-view.ant-picker-cell-in-range:before {
    background: rgba(255, 187, 84, 0.2);
  }
  &
    .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
      .ant-picker-cell-range-end-single
    ):before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
      .ant-picker-cell-range-start-single
    ):before {
    background: rgba(255, 187, 84, 0.2);
  }
`;
